<template>
  <div>
    <Breadcrumbs />
    <div class="wrapper mt-5 mb-5 pb-5">
      <div class="container cms-page">
        <div class="fs-5">          
          <div class="collapse collapse-read-more collapse-mobile" id="collapse-read-more-1" style="--height:350">
            <h2 class="h3 text-black mt-5 mb-3">{{ cmsPageContent.title }}</h2>
              <div id="html-body">
                <ClientOnly>
                  <VRuntimeTemplate
                    v-if="cmsPageContent.content"
                    :template="`<div class='cms-content'>${unescape(cmsPageContent.content)}</div>`"
                  ></VRuntimeTemplate>
                </ClientOnly>
              </div>
          </div>
          <a class="collapse-read-more-toggle" data-toggle="collapse" href="#collapse-read-more-1" role="button" aria-expanded="false" aria-controls="collapse-read-more-1">lees</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from "@/esf_antarctica_lederhosenland/core/components/breadcrumb/Breadcrumbs.vue";
//import SidebarLinks from "@/esf_antarctica_lederhosenland/core/components/SidebarLinks";
import VRuntimeTemplate from "v-runtime-template";
import config from "@config";
import { Logger } from "@storefront/core/lib/logger";
import ClientOnly from "vue-client-only";

export default {
  name: "StaticPage",
  components: {
    Breadcrumbs,
    VRuntimeTemplate,
    ClientOnly
  },
  computed: {
    cmsPageContent() {
      return this.$store.state.cmsPage.current;
    },
  },
  methods: {
    unescape(str) {

      if (typeof document === 'undefined') {
        console.warn('Document is not available.');
        return str;
      }

      // 1. Unescape the string
      str = str.replace(/&lt;/g, "<").replace(/&gt;/g, ">");

      // 2. Extract all <style>...</style> blocks
      const styleMatches = str.match(/<style[^>]*>[\s\S]*?<\/style>/gi) || [];

      // 3. Join all extracted styles
      const styles = styleMatches.map(styleTag => {
        // Remove the <style> and </style> tags themselves
        return styleTag.replace(/<\/?style[^>]*>/gi, '');
      }).join('\n');

      // 4. Remove all <style> tags from the original string
      const cleanedContent = str.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');

      // 5. Apply styles to page
      if (styles) {
        const styleElement = document.createElement('style');
        styleElement.type = 'text/css';
        styleElement.innerHTML = styles;
        document.head.appendChild(styleElement);
      }

      // 6. Return cleaned content
      return cleanedContent;
    }
  },
  mounted() {
    const bcrumb = { current: this.cmsPageContent.title, routes: [] };
    this.$store.commit("breadcrumbs/set", bcrumb);
    Logger.debug("metaInfo", "static", config)();
  },
  metaInfo() {
    return {
      meta: [
        { name: "title", content: this.cmsPageContent.meta_title },
        { name: "keywords", content: this.cmsPageContent.meta_keywords },
        { name: "description", content: this.cmsPageContent.meta_description },
      ],
      title: this.cmsPageContent.title,
      link: [
        {
          rel: "canonical",
          href: config.app_url + this.$route.fullPath,
        },
      ],
    };
  },
  data: () => ({
    sidebarData: {
      heading: "Categorie",
      options: [
        { displayName: "Gentlemen", linkTo: "#", active: false },
        { displayName: "Women", linkTo: "#", active: false },
        { displayName: "Bicycle clothing sets", linkTo: "#", active: false },
        { displayName: "Children", linkTo: "#", active: false },
        { displayName: "Cycling shoes", linkTo: "#", active: false },
        { displayName: "For your bike", linkTo: "#", active: false },
        { displayName: "For your body", linkTo: "#", active: false },
        { displayName: "Brands", linkTo: "#", active: false },
        { displayName: "Cycling books", linkTo: "#", active: false },
        { displayName: "Gift voucher", linkTo: "#", active: false },
      ],
    },
  }),
};
</script>
<style lang="scss">
.cms-content {
  padding-bottom: 50px;
  b,
  strong {
    font-weight: 500;
  }
  table {
    @media screen and (max-width: 670px) {
      max-width: 100vw;
      width: 100% !important;
      td {
        display: block;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
h1 {
  margin-bottom: 16px;
  font-size: 30px;
}
h2 {
  font-size: 24px;
}
ul {
  li {
    padding-left: 15px;
    position: relative;

    &:before {
      content: "";
      position: absolute;
      top: 12px;
      left: 1px;
      width: 4px;
      height: 4px;
      background: #000;
      border-radius: 100%;
    }
  }
}

.mb-lg-27 {
  margin-bottom: 27px;
}

.font-weight-medium {
  font-weight: 500;
}
.sidebar {
  background: $grayColor;
  padding: 11px 26px 16px;
}

.sidebar-links {
  list-style: none;
  padding: 3px 0;
  margin: 0;

  li {
    + li {
      margin-top: 6px;
    }
  }

  a {
    position: relative;

    &.active {
      font-weight: 500;
      &:before {
        content: "";
      }
    }

    &:before {
      content: none;
      position: absolute;
      top: -1px;
      left: -24px;
      width: 3px;
      height: 29px;
      background: $red;
    }

    &:hover {
      color: #000 !important;
      font-weight: 500;
      &:before {
        content: "";
      }
    }
  }
}

.sidebar-heading {
  display: block;
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 7px;
}
</style>

